import PastImagesQuickOrder from './PastImagesQuickOrder';

export default PastImagesQuickOrder;
